import * as React from "react";
import { Input, makeStyles } from "@fluentui/react-components";
import { isValidColumn } from "../../../utils/columnUtils";
import { highlightColumnRange } from "../../../excel/highlightColumn";

export interface ColumnInputProps {
  value: string;
  onChange: (value: string) => void;
  startRow: number;
  endRow: number;
  disabled?: boolean;
}

const useStyles = makeStyles({
  root: {
    width: "60px",
  },
});

const ColumnInput: React.FC<ColumnInputProps> = ({ value, onChange, startRow, endRow, disabled }) => {
  const styles = useStyles();

  const handleFocus = () => {
    const upper = value.toUpperCase();
    if (isValidColumn(upper)) {
      highlightColumnRange(upper, startRow, endRow);
    }
  };

  const handleChange = (_e: unknown, data: { value: string }) => {
    const upper = data.value.toUpperCase();
    onChange(upper);
    if (isValidColumn(upper)) {
      highlightColumnRange(upper, startRow, endRow);
    }
  };

  return (
    <Input
      className={styles.root}
      value={value}
      onChange={handleChange}
      onFocus={handleFocus}
      maxLength={2}
      disabled={disabled}
    />
  );
};

export default ColumnInput;
